import { getCookie } from './common'

export function interceptRequest(config, Qs) {
  const csrftoken = getCookie('csrftoken')
  config.headers['X-CSRFToken'] = csrftoken
  if (config.method.toLowerCase() === 'get') {
    // get请求时的配置
    /**
     * @param params 例如 { a:['b','c'] }
     * @returns 序列化后的参数
     * arrayFormat: 'indices'      =>    a[1]=b&&a[2]==c
     * arrayFormat: 'repeat'       =>    a=b&&a=c
     */
    config.paramsSerializer = params => {
      return Qs.stringify(params, { arrayFormat: 'repeat' })
    }
  } else if (config.method.toLowerCase() === 'post') {
    // post请求时的配置
    config.transformRequest = data => {
      // 检查是否有上传文件
      let hasFile = false
      for (let key in data) {
        if (
          (Array.isArray(data[key]) && data[key][0] instanceof File) ||
          data[key] instanceof File
        ) {
          hasFile = true
          break
        }
      }
      if (hasFile) {
        let formData = new FormData()
        for (let key in data) {
          if (Array.isArray(data[key])) {
            for (let item of data[key]) {
              formData.append(key, item)
            }
          } else {
            formData.append(key, data[key])
          }
        }
        return formData
      } else {
        return Qs.stringify(data, { arrayFormat: 'repeat' })
      }
    }
  }
  return config
}
